// Constants
import { NOTIFICATION_SET_SELECTED } from './notificationsPopupConstants';

export const setSelectedNotification = ({ group }) => ({
    type: NOTIFICATION_SET_SELECTED,
    group,
});
